import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found — check index.html");

// Vite injects the build's `base` setting at `import.meta.env.BASE_URL`.
// Locally that's "/", in production it's "/discoverstudio/". Passing it to
// BrowserRouter as `basename` makes every <Route path="...">, <Link to="...">,
// and `navigate("...")` call relative to the prefix — so route definitions
// and navigation calls remain prefix-agnostic across dev and prod.
//
// React Router strips a trailing slash from `basename` automatically.
const basename = import.meta.env.BASE_URL;

createRoot(root).render(
  <StrictMode>
    <BrowserRouter basename={basename}>
      <App />
    </BrowserRouter>
  </StrictMode>
);
